import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * DetailsPageLayout
 * Classification: custom (template)
 *
 * Entity detail page: a header slot (breadcrumbs/title/actions), a primary
 * content column and a secondary side panel (metadata, related items).
 */
export interface DetailsPageLayoutProps {
  title: string;
  /** Breadcrumbs or back link rendered above the title. */
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  /** Right-hand metadata / related panel. */
  aside?: ReactNode;
  children: ReactNode;
}

export function DetailsPageLayout({
  title,
  breadcrumbs,
  actions,
  aside,
  children,
}: DetailsPageLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {breadcrumbs}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Typography variant="h4" sx={{ flex: 1, fontFamily: 'inherit' }}>
          {title}
        </Typography>
        {actions ? <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box> : null}
      </Box>
      <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
        {aside ? <Box sx={{ width: 320, flexShrink: 0 }}>{aside}</Box> : null}
      </Box>
    </Box>
  );
}
